import { render, staticRenderFns } from "./newSystemMessage.vue?vue&type=template&id=f7abe204&scoped=true"
import script from "./newSystemMessage.vue?vue&type=script&lang=js"
export * from "./newSystemMessage.vue?vue&type=script&lang=js"
import style0 from "./newSystemMessage.vue?vue&type=style&index=0&id=f7abe204&lang=scss"
import style1 from "./newSystemMessage.vue?vue&type=style&index=1&id=f7abe204&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7abe204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7abe204')) {
      api.createRecord('f7abe204', component.options)
    } else {
      api.reload('f7abe204', component.options)
    }
    module.hot.accept("./newSystemMessage.vue?vue&type=template&id=f7abe204&scoped=true", function () {
      api.rerender('f7abe204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/messageLog/newSystemMessage.vue"
export default component.exports